export default __webpack_public_path__ + "b99fbd10b880f41ff8463e20b2919bd7.pdf";